<template>
    <div class="page-about-history">
        <div class="history-cards">
            <div class="card-item" v-for="item in aboutPage.history_cards">
                <div class="card-img" :style="!isMobileChecker ? 'background-image: url(' + item.img + ')' : 'background-image: url(' + item.img_mobile + ')'"></div>
                <div class="card-info">
                    <span>{{ item.year }}</span>
                    <strong>{{ item.title }}</strong>
                    <p v-html="item.desc"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-page-history',
        components: {
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - История',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
            document.body.dataset.page = 'about-history';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/history-section.scss';
    @import '@/styles/components/about-page/respond/history-section-respond.scss';
</style>